export default "__VITE_PUBLIC_ASSET__dbfb7a57__"